import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import AddConsumerComplaint from "./AddConsumerComplaint";
import ViewConsumerComplaints from "./ViewConsumerComplaints";
import BreadCrumb from "Components/Common/BreadCrumb";
import Tabs from "Components/Common/Tabs";
import ViewAllComplaints from "./ViewAllComplaints";
import { CONSUMER, allAdminRoles } from "common/constant";
import { isAuthorizedUser } from "utils";

const consumerComplaintTabs = ["My Complaints", "Add Complaint"];

const Complaint = ({ t }) => {
  const { roles } = useSelector((state) => state.Login);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <BreadCrumb title={t("Complaints")} />
      <Box sx={{ width: "100%" }}>
        {roles.includes(CONSUMER) && (
          <>
            <Tabs
              tabs={consumerComplaintTabs}
              values={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
            />
            {activeTab === 0 ? (
              <Box mt="15px">
                <ViewConsumerComplaints />
              </Box>
            ) : (
              <Box>
                <AddConsumerComplaint setActiveTab={setActiveTab} />
              </Box>
            )}
          </>
        )}
        {isAuthorizedUser(roles, allAdminRoles) ? <ViewAllComplaints /> : null}
      </Box>
    </>
  );
};

Complaint.propTypes = {
  t: PropTypes.func,
};
export default withTranslation()(Complaint);
